export const view013ImageOptions = {
  angle: 'view013',
  staticOptions: {
    HullColour: 1,
    Deck: 1,
    BiminiColor: 1,
    BowOption: 1,
    UpholsteryCockpit: 1,
    Engine: 1,
    AnchorStern: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: [
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view013.js